import colorPalette from '../color-palette';
import colors from '../colors';

export default {
  MuiAccordionSummary: {
    root: {
      minHeight: 0,
      borderBottom: `2px solid ${colorPalette.background.divider}`,
      '&$expanded': {
        minHeight: 0,
        padding: 0,
      },
      padding: 0,
    },
    content: {
      margin: 0,
      '&$expanded': {
        margin: 0,
      },
    },
    expandIcon: {
      margin: 0,
      padding: '10px 4px',
      color: colors.black,
    },
  },
};
